export const CATALOG_TABS = ["products", "prices", "tax-rates"] as const;
export type CatalogTab = (typeof CATALOG_TABS)[number];

export const tabId = (tab: CatalogTab): string => `catalog-tab-${tab}`;
export const panelId = (tab: CatalogTab): string => `catalog-panel-${tab}`;
